class MarketPref extends FormValidation {
    constructor() {
        super();
        this.preferenceForm = this.querySelector('form');
        this.globalMessage = this.querySelector('.global-message');
        this.globalMessageCopy = this.querySelector('.global-message__copy');
        this.accountDrawer = document.querySelector('account-drawer');
    }

    connectedCallback() {
        this.setupEventListeners();
        this.targetDrawer = this.preferenceForm.closest('.drawer__inner');
        this.globalMessage.addEventListener('click', (event) => this.handleGlobalMessageClick(event));
    }

    setupEventListeners() {
        this.preferenceForm.addEventListener('submit', this.formSubmit.bind(this));
    }

    formSubmit(event) {
        event.preventDefault();
        if (!this.hasValidated) return;
        this.handleMarketingPrefUpdate();
    }

    displayMessage(isSuccess, message) {
        this.globalMessage.classList.remove('global-message--success', 'global-message--error');
        this.globalMessage.classList.add(isSuccess ? 'global-message--success' : 'global-message--error');
        this.globalMessageCopy.innerHTML = this.decodeHtml(message);
        this.globalMessage.classList.add('global-message--active');
    }

    decodeHtml(html) {
        var textArea = document.createElement('textarea');
        textArea.innerHTML = html;
        return textArea.value;
    }

    handleMarketingPrefUpdate() {
        const marketingEnabled = this.querySelector("input[name='consent.marketing']");
        var viberCheckbox = this.querySelector("input[name='customer[accepts_viber]']");

        if (this.accountDrawer) this.accountDrawer.toggleLoading();

        var formData = {
            consent: {
                email: marketingEnabled.checked,
                sms: marketingEnabled.checked,
                viber: viberCheckbox ? viberCheckbox.checked : false,
            },
        };

        fetch(getGlobalDomain('/apps/bat-enhanced/newsletter/subscribe'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((jsonData) => {
                if (jsonData.ok) {
                    this.displayMessage(true, window.validationStrings.marketing.onSuccess);
                } else {
                    console.error('Error:', jsonData.message);
                    this.displayMessage(false, window.validationStrings.marketing.onError + `: ${jsonData.message}`);
                }
            })
            .catch((error) => {
                console.error('Error:', error);
                this.displayMessage(false, window.validationStrings.marketing.onError);
            })
            .finally(() => {
                if (this.accountDrawer) this.accountDrawer.toggleLoading();
            });
    }

    handleGlobalMessageClick(event) {
        event.preventDefault();
        this.globalMessage.classList.remove(
            'global-message--success',
            'global-message--error',
            'global-message--active'
        );
    }
}

customElements.define('market-pref', MarketPref);
